// extracted by mini-css-extract-plugin
export default {"lastUpdate":"utils_lastUpdate__xJEaI"};